import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../components/Header/Header";

const History = () => {
  const [stockHistory, setStockHistory] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    // Use dummy data for now
    const fetchStockHistory = async () => {
      try {
        // Dummy data representing stock history
        const dummyData = [
          {
            stockSymbol: "AAPL",
            purchasePrice: 150,
            purchaseDate: "2024-01-10",
            sellPrice: 180,
            sellDate: "2024-02-10",
          },
          {
            stockSymbol: "GOOG",
            purchasePrice: 2000,
            purchaseDate: "2024-03-05",
            sellPrice: 2500,
            sellDate: "2024-04-01",
          },
          {
            stockSymbol: "TSLA",
            purchasePrice: 700,
            purchaseDate: "2024-06-15",
            sellPrice: 650,
            sellDate: "2024-07-15",
          },
        ];

        setStockHistory(dummyData); // Set the dummy data
      } catch (err) {
        setError("Failed to fetch stock history.");
      }
    };

    fetchStockHistory();
  }, []);

  // Function to calculate Profit/Loss and apply styles
  const calculateProfitLoss = (purchasePrice, sellPrice) => {
    const profitLoss = sellPrice - purchasePrice;
    if (profitLoss > 0) {
      return (
        <span style={{ color: "green" }}>
          +${profitLoss.toFixed(2)}
        </span>
      );
    } else if (profitLoss < 0) {
      return (
        <span style={{ color: "red" }}>
          -${Math.abs(profitLoss).toFixed(2)}
        </span>
      );
    } else {
      return <span>No Profit/Loss</span>;
    }
  };

  return (
    <div>
      <Header />
      <div className="container mt-5">
        <h3 className="text-center mb-4">Stock Purchase & Sale History</h3>

        {error && <p className="text-danger">{error}</p>}

        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Stock Symbol</th>
                <th>Purchase Price</th>
                <th>Purchase Date</th>
                <th>Sell Price</th>
                <th>Sell Date</th>
                <th>Profit/Loss</th> {/* New column for Profit/Loss */}
              </tr>
            </thead>
            <tbody>
              {stockHistory.length > 0 ? (
                stockHistory.map((transaction, index) => (
                  <tr key={index}>
                    <td>{transaction.stockSymbol}</td>
                    <td>{transaction.purchasePrice}</td>
                    <td>{new Date(transaction.purchaseDate).toLocaleDateString()}</td>
                    <td>{transaction.sellPrice}</td>
                    <td>
                      {transaction.sellDate
                        ? new Date(transaction.sellDate).toLocaleDateString()
                        : "Not Sold"}
                    </td>
                    <td>{calculateProfitLoss(transaction.purchasePrice, transaction.sellPrice)}</td> {/* Display Profit/Loss */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No history available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default History;
